import { useSyncExternalStore } from 'react';

/**
 * 화면 밝기 모드 (light / dark)
 * - html 요소에 .dark 를 붙이면 tailwind 색 변수(src/theme-colors.css)가 바뀌어 전 화면이 어두워진다
 * - 고른 값은 이 브라우저에만 기억한다. 고른 적 없으면 다크로 시작한다
 */
const STORAGE_KEY = 'trp_color_mode';
const listeners = new Set();

function readStored() {
  try {
    const v = window.localStorage.getItem(STORAGE_KEY);
    return v === 'dark' || v === 'light' ? v : null;
  } catch (_) {
    return null;
  }
}

// 고른 적 없으면 다크로 시작한다
const DEFAULT_MODE = 'dark';

let current = typeof window === 'undefined' ? DEFAULT_MODE : readStored() || DEFAULT_MODE;

function apply(mode) {
  document.documentElement.classList.toggle('dark', mode === 'dark');
}

/** 첫 렌더 전에 호출해 밝은 화면이 깜빡이지 않게 한다 */
export function initColorMode() {
  apply(current);
}

export function setColorMode(mode) {
  current = mode;
  try {
    window.localStorage.setItem(STORAGE_KEY, mode);
  } catch (_) {}
  apply(mode);
  listeners.forEach((fn) => fn());
}

export function toggleColorMode() {
  setColorMode(current === 'dark' ? 'light' : 'dark');
}

function subscribe(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function useColorMode() {
  return useSyncExternalStore(subscribe, () => current, () => DEFAULT_MODE);
}
